import { breakpoint, BodyText } from '@grays-npm/component-library';
import styled from 'styled-components';
import { StyledHeading as Heading } from '../../pages/styles';

export const StyledBody = styled(BodyText)`
  margin-bottom: ${({ theme }) => theme.spacings[5].rem};
`;

export const StyledHeading = styled(Heading)`
  margin-top: ${({ theme }) => theme.spacings[5].rem};
  margin-bottom: ${({ theme }) => theme.spacings[5].rem};
  color: ${({ theme }) => theme.colors.tints.graysBlue['_1']};

  ${breakpoint('md')`
      margin-top: 0;
  `};
`;
